import { AddressNumberIcon } from "./AddressNumberIcon";
import { AddUserIcon } from "./AddUserIcon";
import { AddUserIconV2 } from "./AddUserIconV2";
import { AgentIcon } from "./AgentIcon";
import { AgentSupportIcon } from "./AgentSupportIcon";
import { ApplyToDefaultIcon } from "./ApplyToDefaultIcon";
import { ArchiveBoxIcon } from "./ArchiveBoxIcon";
import { ArchivedIcon } from "./ArchivedIcon";
import { ArchivedIconV2 } from "./ArchivedIconV2";
import { ArrowBack } from "./ArrowBack";
import { ArrowDownIcon } from "./ArrowDownIcon";
import { ArrowDownV2 } from "./ArrowDownV2";
import { ArrowLeft } from "./ArrowLeft";
import { ArrowRightIcon } from "./ArrowRightIcon";
import { ArrowUpDownIcon } from "./ArrowUpDownIcon";
import { ArrowUpSortIcon } from "./ArrowUpSortIcon";
import { AvatarIcon } from "./AvatarIcon";
import { BlockedIcon } from "./BlockedIcon";
import { BookOutlineIcon } from "./BookOutlineIcon";
import { BoxArchiveIcon } from "./BoxArchiveIcon";
import { BuildingOutlineIcon } from "./BuildingOutlineIcon";
import { BurgerIcon } from "./BurgerIcon";
import { CalculationCorrectionIcon } from "./CalculationCorrectionIcon";
import { CalendarIcon } from "./CalendarIcon";
import { CheckCircleIcon } from "./CheckCircleIcon";
import { CheckIcon } from "./CheckIcon";
import { CheckIconV2 } from "./CheckIconV2";
import { ChecklistIcon } from "./ChecklistIcon";
import { ChevronLeftIconV2 } from "./ChevronLeftIconV2";
import { ChevronRightIcon } from "./ChevronRightIcon";
import { ChevronRightIconV2 } from "./ChevronRightIconV2";
import { ChooseFileIcon } from "./ChooseFileIcon";
import { CirclePlusIcon } from "./CirclePlusIcon";
import { CityIcon } from "./CityIcon";
import { ClarityProcessIcon } from "./ClarityProcessIcon";
import { ClientEvidenceIcon } from "./ClientEvidenceIcon";
import { ClientEvidenceIconV2 } from "./ClientEvidenceIconV2";
import { ClockIcon } from "./ClockIcon";
import { CloseIcon } from "./CloseIcon";
import { CloseIconV2 } from "./CloseIconV2";
import { CommentIcon } from "./CommentIcon";
import { CopyFileIcon } from "./CopyFileIcon";
import { CopyIcon } from "./CopyIcon";
import { CopyIconV2 } from "./CopyIconV2";
import { CopyToBoardIcon } from "./CopyToBoardIcon";
import { CountyIcon } from "./CountyIcon";
import { CreateProfileIcon } from "./CreateProfileIcon";
import { CrossIcon } from "./CrossIcon";
import { DashboardIcon } from "./DashboardIcon";
import { DatabaseIcon } from "./DatabaseIcon";
import { DeleteIcon } from "./DeleteIcon";
import { DiscountIcon } from "./DiscountIcon";
import { DocumentIcon } from "./DocumentIcon";
import { DocumentOutlineIcon } from "./DocumentOutlineIcon";
import { DocumentsStackIcon } from "./DocumentsStackIcon";
import { DotsIcon } from "./DotsIcon";
import { DotsVerticalIcon } from "./DotsVerticalIcon";
import { DownloadIcon } from "./DownloadIcon";
import { DownloadIconV2 } from "./DownloadIconV2";
import { DragIcon } from "./DragIcon";
import { EditIcon } from "./EditIcon";
import { EditMarkIcon } from "./EditMarkIcon";
import { EmailIcon } from "./EmailIcon";
import { EmailIconV2 } from "./EmailIconV2";
import { EmptyBoxOutlineIcon } from "./EmptyBoxOutlineIcon";
import { EvidenceIcon } from "./EvidenceIcon";
import { ExpandIcon } from "./ExpandIcon";
import { ExternalLinkIcon } from "./ExternalLinkIcon";
import { EyesIcon } from "./EyesIcon";
import { FaBookIcon } from "./FaBookIcon";
import { FaCalendarBorderedIcon } from "./FaCalendarBorderedIcon";
import { FaCalendarIcon } from "./FaCalendarIcon";
import { FaChartLineIcon } from "./FaChartLineIcon";
import { FaCheckIcon } from "./FaCheckIcon";
import { FaChevronIcon } from "./FaChevronIcon";
import { FaCircleExclamationIcon } from "./FaCircleExclamationIcon";
import { FaColumnsIcon } from "./FaColumnsIcon";
import { FaExternalIcon } from "./FaExternalIcon";
import { FaEyeIcon } from "./FaEyeIcon";
import { FaEyeSlashIcon } from "./FaEyeSlashIcon";
import { FaFileIcon } from "./FaFileIcon";
import { FaGearIcon } from "./FaGearIcon";
import { FaGripIcon } from "./FaGripIcon";
import { FaLockIcon } from "./FaLockIcon";
import { FaPinIcon } from "./FaPinIcon";
import { FaPlusIcon } from "./FaPlusIcon";
import { FaRefreshIcon } from "./FaRefreshIcon";
import { FaSaveIcon } from "./FaSaveIcon";
import { FaSearchIcon } from "./FaSearchIcon";
import { FaSortAmountDownIcon } from "./FaSortAmountDownIcon";
import { FaTableIcon } from "./FaTableIcon";
import { FaTagIcon } from "./FaTagIcon";
import { FaTrashIcon } from "./FaTrashIcon";
import { FaUploadIcon } from "./FaUploadIcon";
import { FaXmarkIcon } from "./FaXmarkIcon";
import { FileOutlineIcon } from "./FileOutlineIcon";
import { FilterIcon } from "./FilterIcon";
import { FlagIcon } from "./FlagIcon";
import { FlagOutlineIcon } from "./FlagOutlineIcon";
import { FolderIcon } from "./FolderIcon";
import { GearIcon } from "./GearIcon";
import { GoogleIcon } from "./GoogleIcon";
import { HearingDatesIcon } from "./HearingDatesIcon";
import { HelpIcon } from "./HelpIcon";
import { HidePassword } from "./HidePassword";
import { HomeGreyIcon } from "./HomeGreyIcon";
import { HomeGreyIconV2 } from "./HomeGreyIconV2";
import { HomeIcon } from "./HomeIcon";
import { HomeIconV2 } from "./HomeIconV2";
import { ImageFileIcon } from "./ImageFileIcon";
import { InfoIcon } from "./InfoIcon";
import { InfoIcons } from "./InfoIcons";
import { IntegrationIcon } from "./IntegrationIcon";
import { InvoicesIcon } from "./InvoicesIcon";
import { LeadIcon } from "./LeadIcon";
import { LikeIcon } from "./LikeIcon";
import { LinkedIcon } from "./LinkedIcon";
import { LocationIcon } from "./LocationIcon";
import { LocationIconFilled } from "./LocationIconFilled";
import { LocationOutlineIcon } from "./LocationOutlineIcon";
import { LogoutIcon } from "./LogoutIcon";
import { LogoutIconV2 } from "./LogoutIconV2";
import { MailingTabIcon } from "./MailingTabIcon";
import { MapOutlineIcon } from "./MapOutlineIcon";
import { MarketValueDownIcon } from "./MarketValueDownIcon";
import { MassUploadIcon } from "./MassUploadIcon";
import { MembersIcon } from "./MembersIcon";
import { MinusIcon } from "./MinusIcon";
import { MoveToBoardIcon } from "./MoveToBoardIcon";
import NotFound from "./NotFound";
import { NotificationIcon } from "./NotificationIcon";
import { PaperclipIcon } from "./PaperclipIcon";
import { PaymentHistoryIcon } from "./PaymentHistoryIcon";
import { PencilIconV2 } from "./PencilIconV2";
import { PeopleIcon } from "./PeopleIcon";
import { PhoneIcon } from "./PhoneIcon";
import { PhoneIconV2 } from "./PhoneIconV2";
import { PinIcon } from "./PinIcon";
import { PlayIcon } from "./PlayIcon";
import { PlusIcon } from "./PlusIcon";
import { PrefilledIcon } from "./PrefilledIcon";
import { PrintIcon } from "./PrintIcon";
import { PropertiesIcon } from "./PropertiesIcon";
import { PropertyIcon } from "./PropertyIcon";
import { PropertyOutlineIcon } from "./PropertyOutlineIcon";
import { ProtestedAccountIcon } from "./ProtestedAccountIcon";
import { PTPWordmark } from "./PTPWordmark";
import { ReferralIcon } from "./ReferralIcon";
import { RefreshOutlineIcon } from "./RefreshOutlineIcon";
import { ReloadIcon } from "./ReloadIcon";
import { RemoveIcon } from "./RemoveIcon";
import { RemoveIconV2 } from "./RemoveIconV2";
import { RestoreIcon } from "./RestoreIcon";
import { RotateRightIcon } from "./RotateRightIcon";
import { SaveOutlineIcon } from "./SaveOutlineIcon";
import { SearchIcon } from "./SearchIcon";
import { SearchIconV2 } from "./SearchIconV2";
import { SendMailIcon } from "./SendMailIcon";
import { SettingsIcon } from "./SettingsIcon";
import { ShowPasswordIcon } from "./ShowPasswordIcon";
import { SlashCircleIcon } from "./SlashCircleIcon";
import { StreetIcon } from "./StreetIcon";
import { SuccessIcon } from "./SuccessIcon";
import { SuccessIconV2 } from "./SuccessIconV2";
import { TableGridIcon } from "./TableGridIcon";
import { TagOutlineIcon } from "./TagOutlineIcon";
import { TaskListIcon } from "./TaskListIcon";
import { TrashIcon } from "./TrashIcon";
import { TrashIconV2 } from "./TrashIconV2";
import { TrashIconV3 } from "./TrashIconV3";
import { TrendUpIcon } from "./TrendUpIcon";
import { UnArchivedIcon } from "./UnArchivedIcon";
import { UnitIcon } from "./UnitIcon";
import { UnlinkedIcon } from "./UnlinkedIcon";
import { UploadIcon } from "./UploadIcon";
import { UserGroupIcon } from "./UserGroupIcon";
import { UserIcon } from "./UserIcon";
import { UserIconV2 } from "./UserIconV2";
import { UsersOutlineIcon } from "./UsersOutlineIcon";
import { WarningIcon } from "./WarningIcon";
import { WarningTriangleIcon } from "./WarningTriangleIcon";
import { XCircleIcon } from "./XCircleIcon";
import { ZipIcon } from "./ZipIcon";

export const Icons = {
  UserIcon,
  CopyIcon,
  CopyIconV2,
  CopyFileIcon,
  CopyToBoardIcon,
  ShowPasswordIcon,
  SearchIconV2,
  ZipIcon,
  ArrowUpSortIcon,
  ArrowUpDownIcon,
  CountyIcon,
  AddressNumberIcon,
  StreetIcon,
  TagOutlineIcon,
  CityIcon,
  UnitIcon,
  ArrowBack,
  AddUserIcon,
  ArrowDownV2,
  HomeGreyIcon,
  HomeGreyIconV2,
  RemoveIcon,
  RemoveIconV2,
  HidePassword,
  HomeIcon,
  HomeIconV2,
  ArrowRightIcon,
  ArrowLeft,
  LogoutIcon,
  LogoutIconV2,
  DashboardIcon,
  DotsIcon,
  DotsVerticalIcon,
  LeadIcon,
  UserGroupIcon,
  CrossIcon,
  CheckIcon,
  CheckIconV2,
  CheckCircleIcon,
  CirclePlusIcon,
  ChevronRightIcon,
  ClockIcon,
  SlashCircleIcon,
  WarningTriangleIcon,
  XCircleIcon,
  PrefilledIcon,
  PrintIcon,
  SaveOutlineIcon,
  PTPWordmark,
  PropertyIcon,
  PropertyOutlineIcon,
  InfoIcon,
  IntegrationIcon,
  ChooseFileIcon,
  ArchiveBoxIcon,
  CalendarIcon,
  ChecklistIcon,
  TableGridIcon,
  TaskListIcon,
  ChevronLeftIconV2,
  ChevronRightIconV2,
  CloseIconV2,
  CommentIcon,
  PaperclipIcon,
  CalculationCorrectionIcon,
  LikeIcon,
  EditIcon,
  EditMarkIcon,
  EyesIcon,
  ExternalLinkIcon,
  BookOutlineIcon,
  BoxArchiveIcon,
  BurgerIcon,
  HelpIcon,
  DocumentIcon,
  DocumentOutlineIcon,
  DocumentsStackIcon,
  HearingDatesIcon,
  ClarityProcessIcon,
  LocationIcon,
  LocationOutlineIcon,
  PropertiesIcon,
  PaymentHistoryIcon,
  PencilIconV2,
  InvoicesIcon,
  InfoIcons,
  ImageFileIcon,
  LinkedIcon,
  UnlinkedIcon,
  BlockedIcon,
  FilterIcon,
  FlagIcon,
  FlagOutlineIcon,
  GearIcon,
  TrashIcon,
  TrashIconV2,
  TrashIconV3,
  ReloadIcon,
  RestoreIcon,
  RotateRightIcon,
  SearchIcon,
  WarningIcon,
  ProtestedAccountIcon,
  SettingsIcon,
  SendMailIcon,
  PlayIcon,
  PlusIcon,
  PinIcon,
  MembersIcon,
  MinusIcon,
  EvidenceIcon,
  ExpandIcon,
  NotFound,
  ApplyToDefaultIcon,
  ArchivedIcon,
  ArchivedIconV2,
  UnArchivedIcon,
  UploadIcon,
  CloseIcon,
  ClientEvidenceIcon,
  GoogleIcon,
  UserIconV2,
  EmailIconV2,
  PhoneIconV2,
  AddUserIconV2,
  ClientEvidenceIconV2,
  SuccessIcon,
  SuccessIconV2,
  AvatarIcon,
  ArrowDownIcon,
  DatabaseIcon,
  DeleteIcon,
  DownloadIcon,
  DownloadIconV2,
  DragIcon,
  DiscountIcon,
  AgentIcon,
  AgentSupportIcon,
  CreateProfileIcon,
  EmailIcon,
  PhoneIcon,
  LocationIconFilled,
  NotificationIcon,
  ReferralIcon,
  PeopleIcon,
  MailingTabIcon,
  MapOutlineIcon,
  MarketValueDownIcon,
  MoveToBoardIcon,
  UsersOutlineIcon,
  TrendUpIcon,
  BuildingOutlineIcon,
  FileOutlineIcon,
  EmptyBoxOutlineIcon,
  RefreshOutlineIcon,
  FaBookIcon,
  FaCalendarBorderedIcon,
  FaCalendarIcon,
  FaChartLineIcon,
  FaCheckIcon,
  FaChevronIcon,
  FaCircleExclamationIcon,
  FaColumnsIcon,
  FaExternalIcon,
  FaEyeIcon,
  FaEyeSlashIcon,
  FaFileIcon,
  FolderIcon,
  MassUploadIcon,
  FaGearIcon,
  FaGripIcon,
  FaLockIcon,
  FaPinIcon,
  FaPlusIcon,
  FaRefreshIcon,
  FaSaveIcon,
  FaSearchIcon,
  FaSortAmountDownIcon,
  FaTableIcon,
  FaTagIcon,
  FaTrashIcon,
  FaUploadIcon,
  FaXmarkIcon,
};
